// src/screens/ReturnPolicyPage.jsx
import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const ReturnPolicyPage = () => {
  return (
    <>
      <Header />
      <div className="page-with-footer">
        <main className="page-main">
          <div className="site-shell">
            <div className="site-shell-inner">

              <section className="pt-5 pb-2 text-center">
                <h1 className="fw-bold display-5 mb-3" style={{color: "#A30003" }}>Política de Devolución</h1>
                <p className="text-muted fs-5 mx-auto" style={{ maxWidth: "900px", color: "#A30003" }}>
                  En <strong>AltaModa</strong>{" "} buscamos garantizar la satisfacción de nuestros clientes mediante un proceso claro de cambios.
                </p>
              </section>

              <section className="pb-5 pt-4">
                <div className="row justify-content-center">
                  <div className="col-lg-9">

                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      Se permiten cambios de producto dentro de los cinco (5) días hábiles posteriores a la entrega, siempre que la prenda se encuentre en perfecto estado, sin uso y con sus etiquetas originales. Para solicitar un cambio, el cliente debe comunicarse a través de nuestros canales oficiales indicando la información del pedido.
                    </p>

                    <p className="fs-5 pt-3 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      Los costos asociados al cambio podrán ser asumidos por el cliente, según el caso.
                    </p>

                  </div>
                </div>
              </section>

            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ReturnPolicyPage;
